import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';
import footerlogo from './../assets/img/logo/logo.svg';
import { ReactComponent as Feedback } from '../assets/icons/loudspeaker.svg';
import FeedbackForm from '../sharedcomponents/FeedbackForm/FeedbackForm';

const Footer = () => {
  const [visible, setVisible] = useState(false);
  const location = useLocation();
  const { authState } = useOktaAuth();

    // Check if current page is registration page or user is not authenticated
  const isRegistrationPage = location.pathname.includes('/user-registration/');
  const isUserAuthenticated = authState?.isAuthenticated;
  const showFeedback = isUserAuthenticated && !isRegistrationPage;

  return (
    <footer className="footer">
      <Container fluid>
        <div className="text-muted d-flex">
          <div className="position-relative text-start pt-1 w-50">
            <ul className="list-inline">
              <li className="list-inline-item text-dark">
                <a
                  className="footer-links"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.spglobal.com/en/terms-of-use"
                >
                  Website Terms of Use
                </a>
              </li>
              <li className="list-inline-item text-dark">
                <a
                  className="footer-links"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.spglobal.com/en/privacy/privacy-policy-english"
                >
                  Privacy Policy
                </a>
              </li>
              <li className="list-inline-item text-dark">
                <a
                  className="footer-links"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.spglobal.com/en/cookie-notice"
                >
                  Cookie Notice
                </a>
              </li>
            </ul>
            <p className="copyright-text">
              &copy; {new Date().getFullYear()}{' '}
              <span href="/" className="">
                S&P Global
              </span>
            </p>
          </div>
          {showFeedback && (
            <div className="ms-auto">
              <Feedback
                className="cursor-pointer mt-2"
                onClick={() => setVisible(true)}
              />
            </div>
          )}
        </div>
      </Container>
      {showFeedback && <FeedbackForm visible={visible} setVisible={setVisible} />}
    </footer>
  );
};

export default Footer;
